import {useMemo, useState} from "react";
import {Link} from "react-router-dom";
import chatbotRobot from "../../../images/helpclic-chatbot-robot-v2.png";

const CONTACT = "Cette question dépasse le périmètre de l'assistant. Contactez Help Clic au +33 7 80 90 40 04 ou à support@help-clic.fr.";

const getAnswer = (question) => {
  const value = String(question || "").toLowerCase();
  if (/annonce|demande|besoin|publier/.test(value)) {
    return "Créez une annonce, choisissez le service, décrivez votre besoin, indiquez l'adresse et votre budget. Après validation, les prestataires peuvent vous proposer une intervention.";
  }
  if (/prestataire|professionnel|artisan|choisir/.test(value)) {
    return "Vous pouvez rechercher un prestataire par service, zone et type de profil, consulter ses vérifications et évaluations, puis le contacter depuis son profil.";
  }
  if (/paiement|payer|carte|facture|rembours/.test(value)) {
    return "Le paiement est sécurisé et déclenché depuis la proposition acceptée. Les factures sont disponibles dans Mes factures. Pour un remboursement ou un litige, utilisez le Centre d'aide.";
  }
  if (/intervention|rendez|rdv|annul|report/.test(value)) {
    return "Le suivi, le report et la clôture se font dans Mes interventions. Les conditions applicables dépendent de l'état et de la proximité du rendez-vous.";
  }
  if (/compte|profil|inscription|supprim/.test(value)) {
    return "Gérez vos informations et vérifications dans Mon profil. Un compte supprimé peut être restauré pendant 30 jours avec le même e-mail ou le même réseau social.";
  }
  if (/condition|confidential|donnée|legal/.test(value)) {
    return "Les règles d'utilisation et de protection des données sont disponibles dans les Conditions générales de Help Clic.";
  }
  if (/bonjour|bonsoir|salut|hello/.test(value)) {
    return "Bonjour ! Je peux vous guider sur les annonces, les prestataires, les interventions, les paiements et votre compte Help Clic.";
  }
  return CONTACT;
};

const QUICK_QUESTIONS = [
  "Comment publier une annonce ?",
  "Comment choisir un prestataire ?",
  "Comment fonctionne le paiement ?",
];

export default function HelpClicChatbot() {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([
    {from: "bot", text: "Bonjour, je suis l'assistant Help Clic. Comment puis-je vous aider ?"},
  ]);
  const canSend = useMemo(() => input.trim().length > 0, [input]);

  const ask = (question) => {
    const clean = String(question || "").trim();
    if (!clean) return;
    setMessages((current) => [
      ...current,
      {from: "user", text: clean},
      {from: "bot", text: getAnswer(clean)},
    ]);
    setInput("");
  };

  return (
    <div className="fixed bottom-5 right-5 z-[10000] flex flex-col items-end">
      {open && (
        <section className="mb-3 flex h-[520px] w-[min(370px,calc(100vw-32px))] flex-col overflow-hidden rounded-2xl bg-white shadow-2xl ring-1 ring-[#d6e2ef]">
          <header className="flex items-center gap-3 bg-gradient-to-r from-[#0022aa] to-[#1a64b9] px-4 py-3 text-white">
            <div className="h-11 w-11 overflow-hidden rounded-full border-2 border-white bg-white" aria-hidden="true">
              <img src={chatbotRobot} alt="" className="h-full w-full object-cover object-top" />
            </div>
            <div className="flex-1">
              <strong className="block">Assistant Help Clic</strong>
              <span className="text-xs text-blue-100">Services à domicile</span>
            </div>
            <button type="button" onClick={() => setOpen(false)} className="text-2xl text-white" aria-label="Fermer">×</button>
          </header>
          <div className="flex-1 space-y-3 overflow-y-auto bg-[#f6f8fc] p-3">
            {messages.map((message, index) => (
              <div key={`${message.from}-${index}`} className={`max-w-[88%] rounded-2xl px-3 py-2 text-sm leading-5 ${message.from === "user" ? "ml-auto bg-[#1a64b9] text-white" : "bg-white text-[#19295c] shadow-sm"}`}>
                {message.text}
              </div>
            ))}
            {messages.length === 1 && (
              <div className="flex flex-wrap gap-2">
                {QUICK_QUESTIONS.map((question) => (
                  <button key={question} type="button" onClick={() => ask(question)} className="rounded-full border border-[#1a64b9] bg-white px-3 py-1 text-left text-xs text-[#1a64b9]">{question}</button>
                ))}
              </div>
            )}
          </div>
          <div className="border-t bg-white p-3">
            <form onSubmit={(event) => {event.preventDefault(); ask(input);}} className="flex gap-2">
              <input value={input} onChange={(event) => setInput(event.target.value)} placeholder="Posez votre question…" className="min-w-0 flex-1 rounded-xl border border-[#d6e2ef] px-3 py-2 text-sm outline-none focus:border-[#1a64b9]" />
              <button type="submit" disabled={!canSend} className="rounded-xl bg-[#ff6600] px-3 font-bold text-white disabled:opacity-40">Envoyer</button>
            </form>
            <Link to="/centre-aide" className="mt-2 block text-center text-xs text-[#1a64b9] underline">Contacter le support</Link>
          </div>
        </section>
      )}
      <button type="button" onClick={() => setOpen((value) => !value)} className="grid h-16 w-16 place-items-center overflow-hidden rounded-full border-4 border-white bg-white shadow-xl" aria-label="Ouvrir l'assistant Help Clic">
        <img src={chatbotRobot} alt="" className="h-full w-full object-cover object-top" />
      </button>
    </div>
  );
}
